import React from 'react';
import styled from 'styled-components';
import { DoctorInfo, Order } from '@/apis/order/interface';
import ImageWithAuthView from '@/components/ImageWithAuthView';
import TextComponent from '@/components/TextComponent';
import { ReactComponent as LeftCaretInCircle } from '@/assets/images/order/leftCaretInCircle.svg';
import { ReactComponent as RightCaretInCircle } from '@/assets/images/order/rightCaretInCircle.svg';
import { ReactComponent as Close } from '@/assets/images/common/close.svg';

interface Props {
  order: Order;
  imageIdx: number;
  setImageIdx: (value: number) => void;
  setImageModal: (value: boolean) => void;
  originalName: string;
}

const ImageZoomModal = (props: Props) => {
  const { order, setImageModal, imageIdx, setImageIdx, originalName } = props;
  const { prescriptions } = order;
  const hasPrescription = !!prescriptions.length;

  const uri = hasPrescription
    ? `/images/${prescriptions[imageIdx].prescriptionId}/original`
    : '';
  const fileType = hasPrescription
    ? prescriptions[imageIdx].filename.split('.')[1]
    : '';

  const renderHeader = () => {
    return (
      <>
        <Header>
          <HeaderTitle>{`${order.username}님의 처방전 (${imageIdx + 1}/${
            prescriptions.length
          })`}</HeaderTitle>

          <Close onClick={() => setImageModal(false)} />
        </Header>
      </>
    );
  };

  const prevImage = () => {
    setImageIdx(imageIdx - 1);
  };
  const nextImage = () => {
    setImageIdx(imageIdx + 1);
  };

  return (
    <Wrapper>
      <CardBody>
        {renderHeader()}
        <PrevButton
          show={+(hasPrescription && !!imageIdx)}
          onClick={prevImage}
        />
        <ImageWrapper>
          <ImageBody>
            <ImageWithAuthView
              orderId={order.id}
              id={'zoomModal'}
              uri={uri}
              fileType={fileType}
              scale={1.8}
              originalName={originalName}
              doctorInfo={order.doctorInfo}
            />
          </ImageBody>
        </ImageWrapper>
        <NextButton
          show={+(hasPrescription && imageIdx + 1 !== prescriptions.length)}
          onClick={nextImage}
        />
      </CardBody>
    </Wrapper>
  );
};

export default ImageZoomModal;

const Wrapper = styled.div`
  width: 900px;
`;

const CardBody = styled.div`
  display: flex;
  flex-flow: column;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 80vh;
`;

const ImageWrapper = styled.div`
  height: 87vh;
  overflow-y: scroll;
`;

const ImageBody = styled.div`
  position: relative;
`;

const PrevButton = styled(LeftCaretInCircle)<{ show: number }>`
  ${({ show }) => !show && 'display: none'};
  position: absolute;
  left: 15px;
  cursor: pointer;
  z-index: 99;
`;

const NextButton = styled(RightCaretInCircle)<{ show: number }>`
  ${({ show }) => !show && 'display: none'};
  position: absolute;
  right: 15px;
  cursor: pointer;
  z-index: 99;
`;

const Header = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 1.5rem;
  padding-left: 2rem;
  width: 100%;
`;

const HeaderTitle = styled(TextComponent)`
  font-size: 20px;
  font-weight: 600;
`;
